import React from 'react'
import PropTypes from 'prop-types'
import {
    Text,
    Box,
    Image,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getUrl} from '../../../../utils/cloudinary-utils'

export const HeroCustomTextBanner = ({
    variant = 'default',

    desktopPromotionPosition = 'top-right',
    mobilePromotionPosition = 'top-right',
    desktopPromotionBackground = 'white',
    mobilePromotionBackground = 'white',

    titleText,
    titleFontFamily = 'caslon',
    titleColor = 'black',
    titleTag = 'p'
}) => {
    const styles = useMultiStyleConfig('HeroCustomTextBanner', {variant})

    const getTextTransform = (fontFamily) => {
        if (fontFamily === 'brandon-grotesque') {
            return 'uppercase'
        } else if (fontFamily === 'caslon-italic') {
            return 'lowercase'
        } else {
            return 'none'
        }
    }

    const titleTextTransform = getTextTransform(titleFontFamily)

    const renderTitle = (text) => {
        return text.split('$').map((part, index) => (
            <React.Fragment key={index}>
                {index > 0 && (
                    <Text as="span" marginRight="3px">
                        <Image
                            {...styles.titleDollarSign}
                            alt="Dollar Sign"
                            src={getUrl('UIImages/images/dollar-sign.svg')}
                        />
                    </Text>
                )}
                {part}
            </React.Fragment>
        ))
    }

    return (
        titleText && (
            <Box
                background={{base: mobilePromotionBackground, lg: desktopPromotionBackground}}
                right={{
                    base: mobilePromotionPosition === 'top-right' ? 0 : 'initial',
                    lg: desktopPromotionPosition === 'top-right' ? 0 : 'initial'
                }}
                display={{
                    base: mobilePromotionPosition !== 'hide' ? 'block' : 'none',
                    lg: desktopPromotionPosition !== 'hide' ? 'block' : 'none'
                }}
                {...styles.wrapper}
            >
                {titleText && (
                    <Text
                        as={titleTag}
                        fontFamily={titleFontFamily}
                        color={titleColor}
                        textTransform={titleTextTransform}
                        fontStyle={titleFontFamily === 'caslon-italic' ? 'italic' : 'normal'}
                        {...styles.title}
                    >
                        {renderTitle(titleText)}
                    </Text>
                )}
            </Box>
        )
    )
}

HeroCustomTextBanner.propTypes = {
    variant: PropTypes.string,

    desktopPromotionPosition: PropTypes.string,
    mobilePromotionPosition: PropTypes.string,
    desktopPromotionBackground: PropTypes.string,
    mobilePromotionBackground: PropTypes.string,

    titleText: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleColor: PropTypes.string,
    titleTag: PropTypes.string
}

export default HeroCustomTextBanner
